<template>
  <div class="general">
    <div class="banner">
      <img src="@/assets/images/textbook/banner.png" alt="" />
    </div>
    <!-- <div class="title">
        <img src="@/assets/images/general/title.png" alt="" />
      </div> -->
    <div class="title">
      <div class="line-left">
        <img src="@/assets/images/textbook/lineLeft.png" alt="" />
      </div>
      <div class="title_book">图书
      </div>
      <div class="title_list">列表</div>
      <div class="line-right">
        <img src="@/assets/images/textbook/lineRight.png" alt="" />
      </div>
    </div>
    <div class="tab">
      <div class="tab_list">
        <div class="tab_item" :class="activeName == index ? 'active' : ''" v-for="(item, index) in tabList" :key="index"
          @click="selectTab(index,item)">{{ item.name }}
          <div class="tab_select" v-show="activeName == index"></div>

        </div>
      </div>
      <div class="line"></div>
      <div class="tag_list">
        <div class="tag" :class="activeTag == index ? 'active' : ''" v-for="(item, index) in tagList" :key="index"
          @click="selectTab2(index,item)">{{ item.name }}
        </div>
      </div>
    </div>
    <div class="container nopadding">
      <div class="book_list">
        <div class="book_item" v-for="(item, index) in bookList" :key="item.id">
          <div class="white" @click="openBook(item)">
            <div class="title_pic" :style="{
              background: `url(${item.cover})`,
              backgroundSize: `207px 293px`,
            }"></div>
            <div class="shadow">

            </div>
          </div>

          <div class="text">
            <div class="text_title" :title="item.name" @click="openBook(item)">{{ item.name }}</div>
            <div class="text_bottom">
              <div class="auth bottom_item">
                <img src="@/assets/images/textbook/auth.png" alt="">{{ item.editor }}
              </div>
              <div class="publish bottom_item">
                <img src="@/assets/images/textbook/publish.png" alt="">{{ item.publish }}
              </div>
              <div class="bottom_line"></div>
              <div class="bottom_read" @click="openVideo(item)"> <img src="@/assets/images/textbook/read.png" alt="">导读
              </div>
            </div>

          </div>
        </div>
      </div>
    </div>
    <el-dialog :visible.sync="dialogVisible" width="860px" :before-close="handleClose" :show-close="false"
      class="videoDialog">
      <div class="video" v-if="videoDetail.id">
        <video :src="videoDetail.video" controls="controls" controlslist="nodownload" :poster="require(`../../assets/images/textbook2/compressed-${videoDetail.id}.png`)"></video>
        <!-- <video :src="videoDetail.video" controls="controls" controlslist="nodownload" :poster="videoDetail.videoCover"></video> -->
        <!-- <img src="@/assets/images/textbook/stop.png" alt="" class="stop_btn">
        <div class="controlBar">
          <div class="control_btn">
            <img src="@/assets/images/textbook/btn.png" alt="">
          </div>
          <div class="control_bar">
            <img src="@/assets/images/textbook/control.png" alt="">
          </div>
        </div> -->
      </div>
      <div class="box" style="height: 420px;"></div>
      <!-- <div class="video_title">{{ videoDetail.name }}</div>
      <div class="auth bottom_item">
        <img src="@/assets/images/textbook/auth.png" alt="">{{ videoDetail.editor }}
      </div>
      <div class="publish bottom_item">
        <img src="@/assets/images/textbook/publish.png" alt="">{{ videoDetail.publish }}
      </div> -->
      <div class="close_btn" @click="handleClose"><img src="@/assets/images/textbook/close.png" alt=""></div>
    </el-dialog>
  </div>
</template>

<script>
import cover1 from "../../assets/images/textbook/back1.png";
import cover2 from "../../assets/images/textbook/back2.gif";
import cover3 from "../../assets/images/textbook/back3.png";
import cover4 from "../../assets/images/textbook/back4.png";
import cover5 from "../../assets/images/textbook/back5.png";
import cover6 from "../../assets/images/textbook/back6.png";
import cover7 from "../../assets/images/textbook/back7.png";
import cover8 from "../../assets/images/textbook/back8.png";
import cover9 from "../../assets/images/textbook/back9.png";
import cover10 from "../../assets/images/textbook/back10.png";
import { get } from "jquery";
const bookList=[
  {
          id: '1752137656290119680',
          name: '职业教育数字教材开发实战',
          editor: "冯立国，安薇",
          publish: '国家开放大学出版社',
          cover: cover1,
          text: " 本书旨在为广大教育工作者和数字内容创作者提供数字教材建设的理念、方法和工具指导，帮助其在实践中减少盲目、少走弯路。全书聚焦实操性、指导性与流程化，按照“数字教材概览——前期总体规划——初期教学设计——中期系统开发——终期产品验收——教材建设实践——教材建设技术”的结构来组织图书内容，以任务驱动的方式，力求提供简洁、易懂、可操作的行动指南。由行业专家冯立国、安薇等联合编写，适合所有对数字教材及教育资源开发与创新感兴趣的学习者参考。",
          url: "https://web.ysy.crtvup.com.cn/#/bookstore/bookstoreDetail?goodsId=1927601902279856128&goodsType=looseleafOrtextbook",
          video:"https://ouchn-prod-public.oss-cn-beijing.aliyuncs.com/goods_file/e86a3626-b1c0-4ea5-a344-227b0860294a.mp4",
          class: 10,
          classId:20,
          videoCover:cover1
        },
        {
          class: 10,
          classId:21,
          id: '1981197902164398080',
          name: '现代教育技术——学科教师数字素养进阶之路',
          editor: "武丽志，林秀钦等",
          publish: '国家开放大学出版社',
          cover: cover2,
          text: " 本书系统论述了数字化与教育变革、教学媒体、智慧校园、技术应用、教学设计与评价等九个方面的内容，旨在帮助广大读者和自学者构建完整的信息化教学知识体系，提升数字素养与技能。内容兼具指导性、实用性与扩展性，编写风格新颖，模块独立，并配有丰富的活动建议。由教育技术领域专家武丽志、林秀钦等编写，能满足教育工作者及社会学习者自主更新知识、轻松驾驭信息技术的需求。",
          url: "https://web.ysy.crtvup.com.cn/#/bookstore/bookstoreDetail?goodsId=1927603069021982720&goodsType=looseleafOrtextbook",
          video:"https://ouchn-prod-public.oss-cn-beijing.aliyuncs.com/goods_file/d2d42e8f-0c28-4920-ad93-e9e98bee431a.mp4"
        },
        {
          class: 11,
          classId:22,
          id: '1976570037020004352',
          name: '社会透视：经典著作中的洞见',
          editor: "唐燕儿等",
          publish: '国家开放大学出版社',
          cover: cover3,
          text: "本书以“经典导读”为切入点，聚焦《梦的解析》《非暴力沟通》《娱乐至死》《中国法律与中国社会》《国富论》五部经典，覆盖个体心理、沟通伦理、文化传播、法治演进与经济规律等社会学核心议题，打破学科壁垒，融合心理学、法学、经济学、传播学等多领域理论，揭示社会现象的复杂性与联动性。本书构建了“怎么读-为什么读-读什么-读的结果考察”四维导读体系，旨在引导广大读者掌握阅读方法、培养批判性思维与社会洞察力。本书由唐燕儿等高校骨干教师团队编写，适合所有希望透过经典深化社会理解、提升人文素养的阅读者。",
          url: "https://web.ysy.crtvup.com.cn/#/bookstore/bookstoreDetail?goodsId=1927603500800413696&goodsType=looseleafOrtextbook",
          video:"https://ouchn-prod-public.oss-cn-beijing.aliyuncs.com/goods_file/a026fafc-070d-4e4c-836d-72049f3fa405.mp4"
        },
        {
          class: 11,
          classId:23,
          id: '1978262934782087168',
          name: '撬动思维：跨学科工具与科学经典导读',
          editor: "凌志林等",
          publish: '国家开放大学出版社',
          cover: cover4,
          text: "本书以“工具性思维”为主线，分为科技与创新、跨学科思维、思维工具应用、经济管理思维、时空与哲学思维、创新创业思维六大模块，导读15部科学经典。旨在服务广大读者和终身学习者，培养其批判性思维、跨学科知识结构与创新能力。内容设计注重知识传授与方法论融合，通过经典阐释与思维工具应用，帮助学习者拓展认知领域，提升解决问题和认知世界的能力。本书由凌志林等高校骨干教师团队编写。",
          url: "https://web.ysy.crtvup.com.cn/#/bookstore/bookstoreDetail?goodsId=1927615409499017216&goodsType=looseleafOrtextbook",
          video:"https://ouchn-prod-public.oss-cn-beijing.aliyuncs.com/goods_file/30e58b37-aacb-4443-a430-21b2b40027de.mp4"
        },
        {
          class: 12,
          classId:24,
          id: '2018232887912042496',
          name: '领导者的冰山',
          editor: "曹宇红",
          publish: '国家开放大学出版社',
          cover: cover5,
          text: "本书由知名领导力教练、心理资本专家曹宇红撰写。通过7个章节，深入探讨自我超越、管理情绪、转化观点、洞察期待、直面真我、激发能量等内在成长议题。旨在引导希望提升自我认知与领导能力的广大读者，通过案例、反思与行动建议，掌握从自我觉察到自我超越的路径。 作者曹宇红将管理学与心理学相结合，为职场人士、管理者及追求个人成长的读者提供内在修炼的实用指南。",
          url: "https://web.ysy.crtvup.com.cn/#/bookstore/bookstoreDetail?goodsId=1927616237546901504&goodsType=looseleafOrtextbook",
          video:"https://ouchn-prod-public.oss-cn-beijing.aliyuncs.com/goods_file/faf7a54a-8217-4196-9092-2e6ef9f9b639.mp4"
        },
        {
          class: 13,
          classId:25,
          id: '2018227890063282176',
          name: '新时代数字生活手册——生活健康篇',
          editor: "李建军",
          publish: '国家开放大学出版社',
          cover: cover6,
          text: "本书结合中老年群体的生理心理特点，针对医疗保健、日常用药等需求，提供数字医疗保健工具的使用指导。内容旨在帮助读者克服运用智能技术的心理障碍，更新健康观念，获取数字化健康管理能力。由内蒙古开放大学李建军副教授编写，适合中老年群体及所有希望利用智能技术管理健康的入门学习者。",
          url: "https://web.ysy.crtvup.com.cn/#/bookstore/bookstoreDetail?goodsId=1927616648521584640&goodsType=looseleafOrtextbook",
          video:"https://ouchn-prod-public.oss-cn-beijing.aliyuncs.com/goods_file/7960ff3a-fe2f-4b9d-964e-d0e89ec1ec6b.mp4"
        },
        {
          class: 13,
          classId:26,
          id: '2018230266090360832',
          name: '新时代数字生活手册——生活娱乐篇',
          editor: "杨国斌",
          publish: '国家开放大学出版社',
          cover: cover7,
          text: " 本书围绕生活服务、智能出行、影音娱乐、美照摄影等六大方向，提供数字生活娱乐的实用指南。编写基于充分调研，采用“操作指引+图文并茂”的方式，手把手帮助中老年及广大初学者使用智能工具满足娱乐需求，提升数字生活获得感。由经济学专家杨国斌编写，内容贴近生活，实用性强。",
          url: "https://web.ysy.crtvup.com.cn/#/bookstore/bookstoreDetail?goodsId=1927617139083186176&goodsType=looseleafOrtextbook",
          video:"https://ouchn-prod-public.oss-cn-beijing.aliyuncs.com/goods_file/e035daf9-3428-4ea8-9533-68c74a069bac.mp4"
        },
        {
          class: 13,
          classId:26,
          id: '2018226223368507392',
          name: '新时代数字生活——移动支付篇',
          editor: "张琳",
          publish: '国家开放大学出版社',
          cover: cover8,
          text: "本书内容以问题为导向，包括移动支付、微信、支付宝、云闪付和财产安全5个单元。本书以平实的语言讲解移动支付的概念，系统讲解微信、支付宝和云闪付三款常用移动支付软件的下载安装、热门活动、常规移动支付功能和其他功能的使用方法，并介绍手机理财和防范网络电信诈骗方法等。内容注重实用性与可读性，通过傻瓜式步骤教学，实现“智慧助老”。作者张琳具备丰富的教学与实践经验，本书是中老年群体及移动支付初学者掌握安全、便捷支付技能的可靠指南。",
          url: "https://web.ysy.crtvup.com.cn/#/bookstore/bookstoreDetail?goodsId=1927617499264847872&goodsType=looseleafOrtextbook",
          video:"https://ouchn-prod-public.oss-cn-beijing.aliyuncs.com/goods_file/284773f8-cc2e-4ac1-99b4-e7f7b6e6a848.mp4"
        },
        {
          class: 13,
          classId:26,
          id: '2018234352479113216',
          name: '新时代数字生活手册——老年人数字素养篇',
          editor: "温书宇",
          publish: '国家开放大学出版社',
          cover: cover9,
          text: "本书分为认知篇、技能篇、教育篇三篇。认知篇介绍了老年人数字素养的概念、我国老年数字素养政策背景及现状分析、如何做合格数字公民。技能篇从我国数字素养和技能框架中提炼出5个重要部分，分别是如何保障个人的网络安全？如何进行在线交流？如何进行在线交易？如何使用数字设备查找和处理信息？如何进行内容创建和编辑？最后教育篇从教育的角度，分为体制、内容、方式、环境、评价等几个方面系统介绍了如何进行数字素养和数字技能教育。由老年教育专家温书宇编写，不仅服务于老年群体，也为关心数字素养与技能的教育工作者、家庭成员及社会学习者提供系统参考，旨在共同助力弥合数字鸿沟。",
          url: "https://web.ysy.crtvup.com.cn/#/bookstore/bookstoreDetail?goodsId=1927617499264847872&goodsType=looseleafOrtextbook",
          video:"https://ouchn-prod-public.oss-cn-beijing.aliyuncs.com/goods_file/da1d59c0-d989-4339-939d-6c41fe422eb5.mp4"
        },
        {
          class: 13,
          classId:27,
          id: '2018235990044446720',
          name: '老年生活环境安全指导——老年人居家与社区户外环境安全',
          editor: "侯淑肖",
          publish: '国家开放大学出版社',
          cover: cover10,
          text: "本书以老年生活环境安全为核心，重点介绍居家与社区户外环境中常见安全风险的识别、预防与干预知识。内容以“实用性”和“通俗性”为原则，旨在为养老服务从业人员、老年人家属及广大社区工作者提供专业指导，帮助其掌握基本的安全评估与照护技能，共同营造安全的老年生活环境。",
          url: "https://web.ysy.crtvup.com.cn/#/bookstore/bookstoreDetail?goodsId=1927617499264847872&goodsType=looseleafOrtextbook",
          video:"https://ouchn-prod-public.oss-cn-beijing.aliyuncs.com/goods_file/5c7bd89e-e124-4c8c-b58d-1d56fff628ef.mp4"
        },
]

export default {
  data() {
    return {
      bookList: bookList,
      activeName: 0,
      tabList: [
      {
        id:"",
        name:"全部",list:[
        {
          id:"",
          name:"全部",
        }
]}  ,
      {
        id:10,
        name:"职业技能",
        list:[
          {
        id:"",
        name:"全部"
      },
          {
            id:20,
            name:"职业发展",
          },
          {
            id:21,
            name:"技能提升",
          }
        ]
      },{
        id:11,
        name:"哲学社科",
        list:[
          {
        id:"",
        name:"全部"
      },
          {
            id:22,
            name:"社会观察",
          },{
            id:23,
            name:"哲学思辨",
          }
        ]
      },
      {
        id:12,
        name:"心理科学",
        list:[
          {
        id:"",
        name:"全部"
      },
          {
            id:24,
            name:"心理成长",
          }
        ]
      },{
        id:13,
        name:"健康生活",
        list:[
          {
        id:"",
        name:"全部"
      },
          {
            id:25,
            name:"身心健康",
          },
          {
            id:26,
            name:"生活方式",
          },
          {
            id:27,
            name:"老年健康",
          }
        ]
      }
    ],
      activeTag: 0,
      tagList: [{
        id:"",
        name:"全部"
      }],
      dialogVisible: false,
      videoDetail: {}

    };
  },
  created() {
this.$store.commit("SET_ISLAYOUT", true);
   },
  methods: {

    selectTab(index,item){
      this.activeName = index
      this.tagList=item.list
      this.activeTag = 0
      this.getBookList()
    },
    selectTab2(index,item){
      this.activeTag = index
      this.getBookList()
      // this.tagList=item.list
    },
    getBookList(){
      let id=this.tabList[this.activeName].id||""
      let id2=this.tagList[this.activeTag].id||""
      if(id2){
        this.bookList=bookList.filter(item=>item.classId==id2)
      }else if(id){
        this.bookList=bookList.filter(item=>item.class==id)
      }else{
        this.bookList=bookList
      }
    },
    openVideo(data) {
      this.dialogVisible = true;
      this.videoDetail = data;
    },
    handleClose() {
      this.dialogVisible = false;
      this.videoDetail = {};
    },
    openBook(item){
    let url=`/#/text-book-details?userId=${this.$route.query.userId}&goodsId=${item.id}&platform=${this.$route.query.platform}`
    window.open(url,'_blank')
    }
  },
};
</script>
<style lang='scss' scoped>
.general {
  background-color: #F9F9F9;
}

.banner {
  margin-bottom: 49px;
  width: 100%;
  height: 477px;

  img {
    width: 100%;
    height: 100%;
  }
}

.title {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 38px;

  .title_book,
  .title_list {
    font-family: Source Han Sans CN;
    font-weight: bold;
    font-size: 36px;
    color: #000000;
    // line-height: 62px;
  }

  .line-left,
  .line-right {
    width: 142px;
    height: 34px;
    display: flex;

    img {
      width: 100%;
      height: 7px;
    }
  }

  .line-left {
    margin-right: 16px;
  }

  .line-right {
    margin-left: 16px;
    flex-direction: column-reverse;
  }

  .title_list {
    color: #0090FF;
  }
}

::v-deep .tab {
  padding: 37px 13px 26px;
  background: #FFFFFF;
  width: 1500px;
  margin: 0 auto 53px;

  .tab_list {
    padding: 0 35px;
    font-family: Source Han Sans CN;
    font-weight: 500;
    font-size: 24px;
    color: #000000;
    display: flex;

    .tab_item {
      min-width: 94px;
      margin-bottom: 9px;
      margin-right: 30px;
      cursor: pointer;
      text-align: center;
    }

    .tab_select {
      margin-top: 16px;
      
      height: 5px;
      background: #0090FF;
      border-radius: 3px;
    }

    .active {
      color: #0090FF;
    }
  }

  .line {
    height: 1px;
    background: #F2F5F9;
    margin-bottom: 23px;
  }

  .tag_list {
    display: flex;
    padding: 0 35px;

    .tag {
      font-family: Source Han Sans CN;
      font-weight: 500;
      font-size: 20px;
      color: #5B5B5B;
      margin-right: 30px;
      min-width: 84px;
      text-align: center;
      cursor: pointer;
    }

    .active {
      color: #0090FF;
    }
  }
}

.container {
  width: 1500px;
  margin: 52px auto 0;
  padding-bottom: 75px;

  .book_list {
    display: flex;
    flex-wrap: wrap;

    // justify-content: space-between;
    .book_item:hover{
      transition: all 0.5s;
      box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.1);
      transform: translate3d(0, -5px, 0)
    }
    .book_item {
      width: 490px;
      height: 300px;
      // border-radius: 4px 4px 4px 4px;
      margin-bottom: 65px;
      position: relative;
      background: #FFFFFF;
      display: flex;
      justify-content: flex-end;
      align-items: center;
      margin-right: calc((100% - 1470px) / 3);

      .back {
        width: 84px;
        height: 88px;
        position: absolute;
        right: 0;
        bottom: 0;
        background: url("../../assets/images/general/item_back.png") no-repeat;
        background-size: 100% 100%;
        opacity: 0.2;
      }

      .text {
        padding: 31px 0;
        margin-right: 24px;
        width: 225px;
        text-align: left;
        height: 100%;
        display: flex;
        flex-direction: column;
        justify-content: space-between;

        .text_title {
          font-family: Source Han Sans CN;
          font-weight: 550;
          font-size: 26px;
          color: #000000;
          line-height: 32px;
          display: -webkit-box;
          -webkit-line-clamp: 2;
          -webkit-box-orient: vertical;
          overflow: hidden;
          text-overflow: ellipsis;
          word-break: break-word;
          cursor: pointer;
        }
        .text_title:hover{
          color: #062988;
        }

        .text_bottom {
          margin-top: 5px;

          .bottom_item {
            display: flex;
            align-items: center;
            font-family: SourceHanSansCN;
            font-weight: 400;
            font-size: 18px;
            color: #939393;
          }

          .auth {
            margin-bottom: 17px;

            img {
              width: 21px;
              height: 27px;
              margin-right: 16px;
            }
          }

          .publish {
            margin-bottom: 29px;

            img {
              width: 32px;
              height: 28px;
              margin-right: 9px;
            }
          }

          .bottom_line {
            width: 100%;
            height: 1px;
            background-color: #E3E3E3;
            margin-bottom: 13px;
          }

          .bottom_read {
            cursor: pointer;
            display: flex;
            align-items: center;
            font-family: SourceHanSansCN;
            font-weight: 400;
            font-size: 20px;
            background: linear-gradient(0deg, #245FFE 10.9375%, #00C8B8 100%);
            -webkit-background-clip: text;
            -webkit-text-fill-color: transparent;
            background-clip: text;

            img {
              width: 27px;
              height: 24px;
              margin-right: 11px;
            }
          }
          .bottom_read:hover{
            opacity: 0.7;
          }
        }
      }
      .white:hover {
        transform: translate3d(0, -5px, 0);
        transition: all 0.5s;
      }
      .white {
        width: 207px;
        height: 293px;
        box-shadow: 8px 6px 0px 0px #F2F5F9;
        border: 1px solid #E3E3E3;
        transform-origin: left bottom;
        // background: url("../../assets/images/general/bg.png");
        background: #ffffff;
        box-shadow: 0 2px 5px rgba(136, 136, 136, 0.3);
        position: absolute;
        left: 10px;
        top: -18px;
        transition: transform 0.5s ease-in-out;
        transform: rotateZ(0deg);
        cursor: pointer;

        .title_pic {
          width: 207px;
          height: 293px;
          box-shadow: 0 2px 5px rgba(136, 136, 136, 0.3);
          transition: transform 0.5s ease-in-out;
          background-size: 100% 100%;
          position: relative;
          z-index: 10;
        }

        .shadow {
          position: absolute;
          top: 8px;
          left: 8px;
          width: 207px;
          height: 293px;
          transform-origin: left bottom;
          transition: transform 0.5s ease-in-out;
          background: rgba(180, 176, 176, 0.1);
          z-index: 9;
        }
      }
    }

    .book_item:nth-child(3n) {
      margin-right: 0;
    }

    // .book_item {
    //   box-shadow: 0 2px 5px rgba(136, 136, 136, 0.3);

    //   .white {
    //     transform-origin: left bottom;
    //     transform: rotateZ(-2deg) translateX(12px);
    //     .shadow {
    //       transform-origin: left bottom;
    //       transform: rotateZ(0deg) translateX(-4px);
    //       .whites {
    //         transform-origin: left bottom;
    //         transform: rotateZ(0deg) translateX(-4px);
    //         .title_pic {
    //           transform-origin: left bottom;
    //           transform: rotateZ(-0deg) translateX(-4px);
    //         }
    //       }
    //     }
    //   }
    // }
  }
}

::v-deep .videoDialog {
  .el-dialog__header {
    display: none;
  }

  .el-dialog__body {
    padding: 0 39px 34px;
    position: relative;
  }

  .close_btn {
    width: 48px;
    height: 48px;
    position: absolute;
    bottom: -70px;
    right: 418px;
    cursor: pointer;

    img {
      width: 100%;
      height: 100%;
    }
  }

  .video {
    position: absolute;
    top: -25px;
    left: 39px;
    width: 786px;
    height: 442px;
    box-sizing: border-box;
    background: #8A8A8A;
    margin-bottom: 30px;
    // #B0D1EB
    box-shadow: 0 6px 25px rgba(176, 209, 235, 1);

    .stop_btn {
      width: 53px;
      height: 53px;
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      cursor: pointer;
    }

    .controlBar {
      width: 460px;
      height: 20px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding: 6px 4px;
      background: #E8E8E8;
      position: absolute;
      bottom: 13px;
      left: 50%;
      transform: translateX(-50%);

      .control_btn {
        width: 11px;
        height: 13px;
        margin-right: 6px;
        cursor: pointer;

        img {
          width: 100%;
          height: 100%;
          display: block;
        }
      }

      .control_bar {
        flex: 1;
        height: 5px;
        background: #FFFFFF;
        cursor: pointer;

        img {
          width: 130px;
          height: 5px;
          display: block;
        }
      }
    }

    video {
      width: 100%;
      height: 100%;
    }
  }

  .video_title {
    font-family: Source Han Sans CN;
    font-weight: bold;
    font-size: 28px;
    color: #000000;
    width: 100%;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    margin-bottom: 31px;
  }

  .bottom_item {
    display: flex;
    align-items: center;
    font-family: SourceHanSansCN;
    font-weight: 400;
    font-size: 18px;
    color: #939393;
  }

  .auth {
    margin-bottom: 17px;

    img {
      width: 21px;
      height: 27px;
      margin-right: 16px;
    }
  }

  .publish {

    img {
      width: 32px;
      height: 28px;
      margin-right: 9px;
    }
  }
}

.nopadding {
  padding-bottom: 0;
}
</style>